import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

/**
 * 大カテゴリー選択時に小カテゴリーを更新する
 * @example
 * <form>
 *  <select
 *    data-controller="large-category-select"
 *    data-large-category-select-url-value="<%= url_for(...) %>"
 *  >...</select>
 * </form>
 */
export class LargeCategorySelectController extends Controller {
  static values = { url: String, query: Object };

  connect() {
    this.element.addEventListener("change", this.#handleChange);
  }

  #handleChange = (e) => {
    const url = new URL(this.urlValue, location);
    url.searchParams.append("event_detail[large_category_id]", e.currentTarget.value);
    if (this.queryValue) {
      for (const [key, value] of Object.entries(this.queryValue)) {
        url.searchParams.append(key, value);
      }
    }
    get(url.toString(), { responseKind: "turbo-stream" });
  };
}
